import { render, staticRenderFns } from "./ExternalLogin.vue?vue&type=template&id=76e22de8&scoped=true&"
import script from "./ExternalLogin.vue?vue&type=script&lang=js&"
export * from "./ExternalLogin.vue?vue&type=script&lang=js&"
import style0 from "./ExternalLogin.vue?vue&type=style&index=0&id=76e22de8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e22de8",
  null
  
)

export default component.exports